import useChartMeasureSelected from "components/charting/hooks/useChartMeasureSelected";
import useOneRepMaxSourceQueryState, { OneRepMaxSource } from "components/charting/hooks/useOneRepMaxSourceQueryState";
import OneRepMaxChartNoDataNoExercise from "./components/OneRepMaxChartNoDataNoExercise";
import OneRepMaxChartNoDataPeriod from "./components/OneRepMaxChartNoDataPeriod";
import OneRepMaxChartNoDataVelocity from "./components/OneRepMaxChartNoDataVelocity";

function OneRepMaxChartNoData() {
  const measureSelected = useChartMeasureSelected();
  const [oneRepMaxSource] = useOneRepMaxSourceQueryState();

  if (!measureSelected) {
    return <OneRepMaxChartNoDataNoExercise />;
  }

  if (oneRepMaxSource === OneRepMaxSource.Manual) {
    return <OneRepMaxChartNoDataPeriod />;
  }

  return <OneRepMaxChartNoDataVelocity />;
}

export default OneRepMaxChartNoData;
